module.exports = __webpack_public_path__ + "assets/img/ebook-7-criteres-ged-ouvert.8282c171.jpg";